import { Action } from 'redux';

export const NOTIFICATION_SHOW = 'NOTIFICATION_SHOW';
export const NOTIFICATION_HIDE = 'NOTIFICATION_HIDE';

export interface ShowNotificationAction extends Action {
  type: typeof NOTIFICATION_SHOW;
  payload: { message: string };
}

export interface HideNotificationAction extends Action {
  type: typeof NOTIFICATION_HIDE;
}

export type NotificationAction =
  | ShowNotificationAction
  | HideNotificationAction;
